import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationsDrawerService {
  opened = new BehaviorSubject<boolean>(false);

  constructor() {}

  open() {
    this.opened.next(true);
  }

  close() {
    if (this.opened.getValue()) {
      this.opened.next(false);
    }
  }
}
